import 'solana-wallets-vue/styles.css'
import './main.css'

import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import { sync } from 'vuex-router-sync'

import routes, { scrollBehavior } from './routes'
import store from './vuex'
import App from './App.vue'

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior,
    // Enable automatic prefetch for all routes immediately
    linkPrefetchStrategy: 'all', // Prefetch all links immediately
    prefetchChunkSize: 10000, // Maximum chunk size to prefetch
    prefetchMaxAge: 5000, // Cache prefetched chunks for 5 seconds
    prefetchOnMouseOver: false, // Don't wait for mouseover
    prefetchOnFocus: false // Don't wait for focus
})

sync(store, router);

const app = createApp(App)

app.use(store)
app.use(router)

// Инициализируем авторизацию
store.dispatch('initializeAuth')

app.mount('#app')
